import axios from "../../../utils/request"

function GET_LIST(params) {
    return axios.get("/information/AInformation/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/information/AInformation/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/information/AInformation/edit",{
        params: {id:params}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/information/AInformation/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/information/AInformation/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/information/AInformation/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/information/AInformation/delete",{
        params: {
            ids:params
        }
    } )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
}